// extracted by mini-css-extract-plugin
export var createdDate = "_ic-1";
export var divider = "_ic-2";
export var headerDivider = "_ic-3";
export var messagesCard = "_ic-0";
export var messagesContainer = "_ic-7";
export var messagesContainerWrapper = "_ic-4";
export var pointerCapturingButtonBoxes = "_ic-a";
export var showLeftPanelButton = "_ic-9";
export var showMoreButton = "_ic-c";
export var showMoreButtonContainer = "_ic-b";
export var summaryTitle = "_ic-6";
export var systemMessageCardWrapper = "_ic-d";
export var topButtons = "_ic-8";
export var withPadding = "_ic-5";